export default "__VITE_ASSET__CWYqeFFv__"